import type { Locale } from "@/lib/i18n";
import { pl, type WJobOffersTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wJobOffersTranslations: Record<Locale, WJobOffersTranslations> = {
  pl,
  en,
  de,
};

export type { WJobOffersTranslations };
